/**
 * Country Profile translations - Portuguese
 */

export const countryProfile = {
  countryProfile: {
    // Page structure
    pageTitle: 'Perfil do País',
    backToRankings: 'Voltar aos Rankings',
    viewFullProfile: 'Ver Perfil Completo',
    
    // Hero section
    yfiScore: 'Índice de Futuros da Juventude',
    vsGlobal: 'vs Média Global',
    classification: 'Classificação',
    region: 'Região',
    
    // Quick stats
    youthPopulation: 'População Jovem',
    jciMembers: 'Membros JCI',
    jciSince: 'JCI Desde',
    neetRate: 'Taxa NEET',
    
    // Section titles
    demographics: 'Demografia & População',
    jciPresence: 'Presença JCI',
    dimensionAnalysis: 'Análise Dimensional',
    mentalHealth: 'Saúde Mental',
    workforce: 'Trabalho & Educação',
    entrepreneurship: 'Empreendedorismo',
    keyPrograms: 'Programas & Organizações Chave',
    sdgAlignment: 'Alinhamento com ODS',
    recommendations: 'Recomendações Estratégicas',
    communityImpact: 'Impacto Comunitário',
    
    // Demographics labels
    totalPopulation: 'População Total',
    medianAge: 'Idade Mediana',
    urbanPopulation: 'População Urbana',
    genderDistribution: 'Distribuição por Gênero',
    racialComposition: 'Composição Racial',
    incomeDistribution: 'Distribuição de Renda',
    
    // Racial composition
    pardo: 'Pardo',
    preto: 'Preto',
    branco: 'Branco',
    other: 'Outros',
    
    // Income levels
    highIncome: 'Alta Renda',
    upperMiddle: 'Média-Alta',
    lowerMiddle: 'Média-Baixa',
    lowIncome: 'Baixa Renda',
    
    // JCI Presence
    affiliationYear: 'Ano de Afiliação',
    currentMembers: 'Membros Atuais',
    yearOverYearGrowth: 'Crescimento Anual',
    historicalPeak: 'Pico Histórico',
    memberProfile: 'Perfil dos Membros',
    ageDistribution: 'Distribuição por Idade',
    educationLevel: 'Nível de Educação',
    genderBalance: 'Equilíbrio de Gênero',
    motivationLevel: 'Nível de Motivação',
    higherEducation: 'Ensino Superior',
    postGraduate: 'Pós-Graduação',
    mastersOrHigher: 'Mestrado ou Superior',
    veryMotivated: 'Muito Motivado',
    motivated: 'Motivado',
    neutral: 'Neutro',
    demotivated: 'Desmotivado',
    
    // Challenges
    keyChallenges: 'Principais Desafios',
    mentalHealthCrisis: 'Crise de Saúde Mental',
    climateAnxiety: 'Ansiedade Climática',
    youthAnxiety: 'Ansiedade Juvenil',
    frequentSadness: 'Tristeza Frequente',
    frequentNervousness: 'Nervosismo Frequente',
    adolescentDisorders: 'Adolescentes com Transtornos',
    girlsAffected: 'Meninas Afetadas',
    boysAffected: 'Meninos Afetados',
    highestGlobally: 'Mais Alto Globalmente',
    neetPopulation: 'Jovens NEET',
    youth: 'Jovens',
    intersectionalGap: 'Lacuna Interseccional',
    blackBrownWomen: 'Mulheres Negras/Pardas',
    whiteMen: 'Homens Brancos',
    
    // Workforce labels
    // Workforce labels
    literacyCrisis: 'Taxa de Alfabetização (2º Ano)',
    higherEducationGap: 'Déficit de Ensino Superior',
    intersectionalNeet: 'NEET Interseccional',
    
    // Entrepreneurship labels
    blackEntrepreneurs: 'Empreendedores Negros',
    informalSector: 'No Setor Informal',
    microentrepreneurs: 'Microempreendedores (MEI)',
    earlyStageEntrepreneurship: 'Empreendedorismo Inicial',
    businessSurvivalRate: 'Sobrevivência de Negócios (2 anos)',
    
    // Programs
    programName: 'Programa',
    programFocus: 'Foco',
    programImpact: 'Impacto',
    
    // SDG
    sdgInitiatives: 'Iniciativas Chave',
    
    // Recommendations
    urgentPriorities: 'Prioridades Urgentes (0-6 meses)',
    mediumTermGoals: 'Metas de Médio Prazo (6-12 meses)',
    longTermVision: 'Visão de Longo Prazo (1-3 anos)',
    
    // Common
    years: 'anos',
    million: 'milhões',
    thousand: 'mil',
    percent: '%',
    ofPopulation: 'da população',
    source: 'Fonte',
    dataNote: 'Dados do Relatório de Impacto JCI 2025, Atlas das Juventudes, IBGE, OMS',
    
    // Not found
    notFound: 'Perfil do país não encontrado',
    notFoundDescription: 'O perfil do país solicitado ainda não está disponível.',
    browseRankings: 'Ver Rankings de Países',

    // NEW: Research Sources Section
    dataSources: 'Fontes de Pesquisa',
    dataSourcesDescription: 'Fontes primárias de dados usadas neste perfil de país',
    primarySources: 'Fontes Primárias',
    methodology: 'Metodologia',
    sampleSize: 'Tamanho da Amostra',
    confidenceLevel: 'Nível de Confiança',
    organization: 'Organização',
    researchYear: 'Ano',
    respondents: 'respondentes',
    
    // NEW: Violence & Safety Section
    violenceSafety: 'Violência e Segurança',
    violenceSafetyDescription: 'Indicadores críticos de segurança que afetam a juventude brasileira',
    youthHomicideShare: 'Proporção de Homicídios de Jovens',
    ofAllHomicides: 'de todos os homicídios',
    racialDisparity: 'Disparidade Racial',
    blackYouthMurderRisk: 'Risco de assassinato de jovens negros',
    timesHigher: 'vezes maior que jovens brancos',
    policeViolence: 'Violência Policial',
    policeViolenceVictims: 'das vítimas de violência policial são negras',
    lgbtqiaViolence: 'Violência LGBTQIA+',
    annualIncrease: 'aumento anual na violência relatada',
    
    // NEW: Organizational Health Section
    organizationalHealth: 'Saúde Organizacional',
    organizationalHealthDescription: 'Métricas de satisfação e engajamento dos membros da JCI Brasil',
    netPromoterScore: 'Net Promoter Score',
    excellent: 'Excelente',
    promoters: 'Promotores',
    passives: 'Passivos',
    detractors: 'Detratores',
    localSatisfaction: 'Satisfação com Org. Local',
    nationalSatisfaction: 'Satisfação com Org. Nacional',
    outOfTen: 'de 10',
    npsBreakdown: 'Detalhamento NPS',
    satisfactionScores: 'Pontuações de Satisfação',
    
    // NEW: SWOT Analysis Section
    swotAnalysis: 'Análise SWOT dos Membros',
    swotAnalysisDescription: 'Avaliação estratégica da pesquisa de membros da JCI Brasil',
    strengths: 'Forças',
    weaknesses: 'Fraquezas',
    opportunities: 'Oportunidades',
    threats: 'Ameaças',
    membersIdentified: 'dos membros identificaram',
    
    // NEW: Geographic Distribution Section
    geographicGap: 'Distribuição Geográfica',
    geographicGapDescription: 'Concentração de membros da JCI Brasil por estado',
    stateConcentration: 'Concentração por Estado',
    southRegionDominance: 'Domínio da Região Sul',
    expansionOpportunity: 'Oportunidade de Expansão',
    expansionOpportunityText: 'Presença mínima nas regiões Norte/Nordeste onde as necessidades de desenvolvimento juvenil são maiores',
    members: 'membros',
    ofMembership: 'dos membros',
    
    // NEW: Training Insights Section
    trainingInsights: 'Participação em Treinamentos',
    trainingInsightsDescription: 'Taxas de conclusão de cursos de treinamento da JCI Brasil',
    noTrainingCompleted: 'Nenhum Treinamento Concluído',
    trainingGapAlert: 'dos membros não concluíram nenhum curso de treinamento JCI',
    courseCompletionRates: 'Taxas de Conclusão de Cursos',
    completionRate: 'Conclusão',
    
    // NEW: SDG Preferences Section  
    sdgPreferences: 'Prioridades dos Membros em ODS',
    sdgPreferencesDescription: 'Principais ODS de interesse entre os membros da JCI Brasil (próximos 3 anos)',
    memberInterest: 'Interesse dos Membros',
    topPriority: 'Prioridade Principal',
    alignsWithNationalNeeds: 'Alinhado com os desafios nacionais da juventude',
    
    // Sample label
    sample: 'Amostra',

    // SWOT Items (20 keys)
    swotItems: {
      companionship: 'Companheirismo',
      committedLeadership: 'Liderança comprometida',
      continuousTraining: 'Capacitação contínua',
      purposeInDna: 'Propósito no DNA',
      qualityNetworking: 'Networking de qualidade',
      inflatedEgos: 'Egos inflados',
      bureaucracy: 'Burocracia',
      inconclusiveProcesses: 'Processos inconclusivos',
      closedOrganization: 'Organização fechada',
      lackOfMarketing: 'Falta de marketing',
      grantsAndSponsorships: 'Editais e patrocínios',
      personalDevelopmentNecessity: 'Necessidade de desenvolvimento pessoal',
      marketDemandsNewLeaders: 'Mercado demanda novos líderes',
      digitalPlatforms: 'Plataformas digitais',
      digitalMarketing: 'Marketing digital',
      rapidSocietalChange: 'Mudança comportamental rápida da sociedade',
      digitalEntertainment: 'Entretenimento digital',
      growingNgos: 'Crescimento de ONGs sociais',
      lackOfRecognizedProjects: 'Falta de projetos reconhecidos',
      societyWithoutTime: 'Sociedade sem tempo',
    },

    // SDG Titles (9 keys)
    sdgTitles: {
      qualityEducation: 'Educação de Qualidade',
      goodHealth: 'Saúde e Bem-Estar',
      decentWork: 'Trabalho Decente e Crescimento Econômico',
      peaceJustice: 'Paz, Justiça e Instituições Eficazes',
      reducedInequalities: 'Redução das Desigualdades',
      genderEquality: 'Igualdade de Gênero',
      noPoverty: 'Erradicação da Pobreza',
      sustainableCities: 'Cidades e Comunidades Sustentáveis',
      climateAction: 'Ação Contra a Mudança Global do Clima',
    },

    // Training Courses (10 keys)
    trainingCourses: {
      jciImpact: 'JCI Impact',
      jciAchieve: 'JCI Achieve',
      projectManagement: 'Gestão de Projetos',
      jciAdmin: 'JCI Admin',
      effectiveLeadership: 'Liderança Eficaz',
      networking: 'Networking',
      communications: 'Comunicações',
      presenter: 'Apresentador',
      leadershipAcademy: 'Academia de Liderança',
      jciDiscover: 'JCI Discover',
    },

    // Brazil-specific Demographics
    brazilDemographics: {
      urbanPopulationBrazil: 'Maioria urbana, ~16M em favelas',
    },

    // Research Methodologies (5 keys)
    methodologies: {
      methodologyAtlas: 'Pesquisa em três etapas: análise quantitativa (dados IBGE), entrevistas qualitativas, recomendações políticas',
      methodologySuaVoz: 'SurveyMonkey, 40,7% de taxa de resposta, ±4% de margem de erro, 95% de confiança',
      methodologyConjuve: 'Pesquisa nacional de juventude sobre atitudes e desafios',
      methodologyConvid: 'Pesquisa comportamental de saúde mental de adolescentes',
      methodologyAtlasViolencia: 'Análise de dados de homicídio e violência',
    },

    // Brazil-specific Recommendations (12 keys)
    brazilRecommendations: {
      urgentRec1: 'Enfrentar a crise NEET de mulheres negras/pardas (taxa de 43,3%)',
      urgentRec2: 'Expandir programas de saúde mental para ansiedade climática',
      urgentRec3: 'Lançar capítulos regionais no Norte/Nordeste',
      urgentRec4: 'Parceria com CUFA para alcance em comunidades de favelas',
      mediumRec1: 'Escalar programas NextGen e JOAJU IT nacionalmente',
      mediumRec2: 'Desenvolver trilhas educacionais específicas da JCI',
      mediumRec3: 'Criar treinamento de defensores de saúde mental para membros',
      mediumRec4: 'Construir parcerias formais com redes de mulheres empreendedoras',
      longRec1: 'Posicionar a JCI Brasil como parceira-chave para a agenda jovem da COP 30',
      longRec2: 'Abordar a transição demográfica com investimento estratégico na juventude',
      longRec3: 'Alcançar equilíbrio de gênero 50-50 com foco em equidade racial',
      longRec4: 'Estabelecer presença em todos os 27 estados brasileiros',
    },
  },
};
